import React from 'react'
import ReactDOM from 'react-dom'
import AppWithResponsive from './components/AppWithResponsive'
import * as serviceWorker from './serviceWorker'
import 'utils/validation'

ReactDOM.render(<AppWithResponsive />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
